<template>
  <div>
    <div v-if="isSmallScreen"> <!-- Assuming you have computed property isSmallScreen -->
      <OurServicesMainPageSmallScreen />
    </div>
    <div v-else>
      <OurServicesMainPageBigScreen />
    </div>
  </div>
</template>

<script>
import OurServicesMainPageSmallScreen from './OurServicesMainPageSmallScreen.vue';
import OurServicesMainPageBigScreen from './OurServicesMainPageBigScreen.vue';

export default {
  components: {
    OurServicesMainPageSmallScreen,
    OurServicesMainPageBigScreen
  },
  computed: {
    isSmallScreen() {
      return window.innerWidth <= 1280;
    }
  },
  mounted() {
    if (this.isSmallScreen) {
      this.loadSmallScreenScripts();
    } else {
      this.loadLargeScreenScripts();
    }
  },
  methods: {
    loadSmallScreenScripts() {
      const script = document.createElement('script');
     
      script.async = true;
      document.head.appendChild(script);
    },
    loadLargeScreenScripts() {
      const script = document.createElement('script');
      
      script.async = true;
      document.head.appendChild(script);
    }
  }
}
</script>
